// TODO Remove workaround from this form and implement an optimal solution
/* eslint no-shadow: 0 */
import React, { Component } from 'react';
import { Modal, Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual, cloneDeep, find } from 'lodash';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import {
	Loader, Form, TextInput, DropDown,
} from '@components/common';

import Actions, { thunks } from '@redux/payments';
import formSchema from './formSchema';

class DisputeFormModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			form : {
				notes  : '',
				reason : undefined,
			},
			formSchema,
			reasonLabel : '',
		};
		// eslint-disable-next-line react/destructuring-assignment
		if (props.disputeReasons.length) this.state.formSchema.schema.properties.reason.data = props.disputeReasons.slice();
		// TODO Remove this warning once this component is optimized
		console.warn('DisputeFormModal: This component is using react-jsonschema-form');
	}

	componentDidMount = () => {
		const { dispatch } = this.props;
		dispatch(thunks.getDisputeReasons());
	}

	UNSAFE_componentWillReceiveProps = ({ disputeReasons, disputeForm }) => {
		const lastProps = this.props;
		if (!isEqual(lastProps.disputeReasons, disputeReasons) || (!lastProps.disputeForm && disputeForm)) this.updateSchema(disputeReasons);
	}

	shouldComponentUpdate = ({
		disputeForm, invoiceId, disputeReasons, disputeConfirmation, loading,
	}, { formSchema }) => {
		const lastProps = this.props;
		const lastState = this.state;
		// Workaround Here: form was removed from shouldComponentUpdate validation
		// so the Form doesn't get updated everytime the state of those fields change
		// TODO Add form to shouldComponentUpdate validation
		return (
			!isEqual(lastProps.disputeForm, disputeForm)
			|| !isEqual(lastProps.invoiceId, invoiceId)
			|| !isEqual(lastProps.disputeReasons, disputeReasons)
			|| !isEqual(lastProps.disputeConfirmation, disputeConfirmation)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(lastState.formSchema, formSchema)
		);
	};

	updateSchema = (data) => {
		const state = cloneDeep(this.state);
		state.formSchema.schema.properties.reason.data = data.slice();
		this.setState(state);
	}

	handleOnCancel = () => {
		const {
			updateModalState,
			updateStoreProperties,
			dispatch,
			fromDetails,
			disputeConfirmation,
			onConfirmedClose,
		} = this.props;
		updateModalState('disputeForm', false);
		if (disputeConfirmation) {
			if (fromDetails) dispatch(push({ pathname : '/payments/list' }));
			else onConfirmedClose();
		}
		this.setState({
			form : {
				notes  : '',
				reason : undefined,
			},
			reasonLabel : '',
		});
		updateStoreProperties({ disputeConfirmation : false });
	}

	formChanged = ({ formData : { notes, reason } }) => {
		const { disputeReasons } = this.props;
		this.setState(
			{
				form : {
					notes,
					reason,
				},
				reasonLabel : find(disputeReasons, 'value', reason - 1).label,
			},
		);
	};

	disputeFormSubmit = () => {
		const { form : { notes, reason } } = this.state;
		const { invoiceId, dispatch } = this.props;

		dispatch(thunks.submitDisputeForm(invoiceId, notes, reason));
	};

	renderForm() {
		const { formSchema, form } = this.state;
		const { invoiceId } = this.props;
		return (
			<div>
				<Modal.Header
					className="bg-gray-12"
				>
					<Modal.Title className="flex flex-direction-column padding-15">
						<span className="padding-bottom-10 color-gray-bayoux font-size-20">Dispute an invoice</span>
						<span className="dispute-label font-size-12 width-fit-content margin-auto">
							You have selected to dispute invoice ID:
							{' '}
							<span className="text-primary">
								{' '}
								{ invoiceId }
								{' '}
							</span>
						</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						keyName="disputeForm"
						formSchema={formSchema}
						// liveValidate={ liveValidate }
						formData={form}
						onSubmit={this.disputeFormSubmit}
						// onError={ this.formError }
						onChange={this.formChanged}
						widgets={
							{
								textInput : TextInput,
								dropDown  : DropDown,
							}
						}
					>
						<div className="text-right margin-top-10 margin-bottom-20">
							<Button
								onClick={this.handleOnCancel}
								bsStyle="danger"
								className="btn btn-primary margin-right-10"
							>
								Cancel
							</Button>
							<Button
								type="submit"
								className="btn btn-primary margin-right-15"
							>
								Submit
							</Button>
						</div>
					</Form>
				</Modal.Body>
			</div>
		);
	}

	renderConfirmation() {
		const { form, reasonLabel } = this.state;
		const { invoiceId } = this.props;
		return (
			<div>
				<Modal.Header
					closeButton
					className="bg-gray-12"
				>
					<Modal.Title className="flex flex-direction-column padding-15">
						<span className="color-gray-bayoux font-size-20 text-center">Dispute Submitted!</span>
						<div className="text-center padding-15">
							<img
								src="/images/checkmark.png"
								alt="Checkmark"
							/>
						</div>
						<span className="color-gray-mine-shaft font-regular font-size-14 text-center padding-bottom-5">
							That was simple! We have notified the officer.
						</span>
						<span className="color-gray-mine-shaft font-regular font-size-14 text-center">
							Please, keep an eye on your email to receive update.
						</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="padding-left-15 font-size-16 color-dark">Dispute Details</p>
					<Col
						md={12}
						xs={12}
						className="margin-bottom-10"
					>
						<p className="margin-0 font-size-14 color-dark">Invoice Id</p>
						<span className="font-light">{ invoiceId }</span>
					</Col>
					<Col
						md={12}
						xs={12}
						className="margin-bottom-10"
					>
						<p className="margin-0 font-size-14 color-dark">Reason for dispute</p>
						<span className="font-light">{ reasonLabel }</span>
					</Col>
					<Col
						md={12}
						xs={12}
					>
						<p className="margin-0 font-size-14 color-dark">Note</p>
						<span className="font-light">{ form.notes }</span>
					</Col>
					<Col
						md={12}
						sm={12}
						className="margin-bottom-30"
					/>
					<div className="text-right margin-top-10 margin-bottom-20">
						<Button
							onClick={this.handleOnCancel}
							className="btn btn-primary margin-right-10"
						>
							Close
						</Button>
					</div>
				</Modal.Body>
			</div>
		);
	}

	render() {
		const { disputeForm, disputeConfirmation, loading } = this.props;
		return (
			<Modal
				keyboard={false}
				backdrop="static"
				show={disputeForm}
				onHide={this.handleOnCancel}
				className="payment-modal"
			>
				<Choose>
					<When condition={!disputeConfirmation}>
						{this.renderForm()}
					</When>
					<Otherwise>
						{this.renderConfirmation()}
					</Otherwise>
				</Choose>
				<Loader active={loading} />
			</Modal>
		);
	}
}

DisputeFormModal.propTypes = {
	disputeForm           : PropTypes.bool.isRequired,
	loading               : PropTypes.bool,
	disputeReasons        : PropTypes.array.isRequired,
	disputeConfirmation   : PropTypes.any.isRequired,
	dispatch              : PropTypes.func.isRequired,
	updateModalState      : PropTypes.func.isRequired,
	updateStoreProperties : PropTypes.func.isRequired,
	invoiceId             : PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	fromDetails      : PropTypes.bool,
	onConfirmedClose : PropTypes.func,
};

DisputeFormModal.defaultProps = {
	invoiceId        : '',
	loading          : false,
	fromDetails      : false,
	onConfirmedClose : () => {},
};

const mapStateToProps = ({
	payments : {
		modals : { disputeForm },
		loading,
		disputeReasons,
		disputeConfirmation,
	},
}) => ({
	disputeForm,
	disputeReasons,
	disputeConfirmation,
	loading : loading.disputeForm,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	updateModalState      : bindActionCreators(Actions, dispatch).updateModalState,
	updateStoreProperties : bindActionCreators(Actions, dispatch).updateStoreProperties,
});

DisputeFormModal.propTypes = {
	dispatch              : PropTypes.func.isRequired,
	disputeConfirmation   : PropTypes.bool,
	disputeForm           : PropTypes.bool,
	disputeReasons        : PropTypes.array,
	fromDetails           : PropTypes.bool,
	invoiceId             : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	loading               : PropTypes.bool,
	onConfirmedClose      : PropTypes.func,
	updateModalState      : PropTypes.func.isRequired,
	updateStoreProperties : PropTypes.func.isRequired,
};

DisputeFormModal.defaultProps = {
	invoiceId           : '',
	fromDetails         : false,
	disputeConfirmation : false,
	disputeForm         : false,
	disputeReasons      : [],
	loading             : false,
	onConfirmedClose    : undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(DisputeFormModal);
